/* loaded by smart-asset */
export default require("./assets/black-pallet.i.svg")